import { render, staticRenderFns } from "./WidgetTop.vue?vue&type=template&id=0bc67548&scoped=true&"
import script from "./WidgetTop.vue?vue&type=script&lang=js&"
export * from "./WidgetTop.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTop.vue?vue&type=style&index=0&id=0bc67548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc67548",
  null
  
)

export default component.exports